import React, { useCallback } from 'react'
import styled from 'styled-components/macro'
import { Container, Typography, Button } from '@mui/material'

import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'

const FeedbackList = React.lazy(() => loadComponent('mfeedback', 'FeedbackList'))

const StyledHeadingText = styled(Typography)`
    margin-bottom: ${({ theme }) => theme.spacing(3)};
    float: left;
`

const StyledHeaderContainer = styled(Container)`
    height: 4vh;
`

export function FeedbackIndexRoute() {
    return (
        <RouteContainer>
            <StyledHeaderContainer disableGutters>
                <StyledHeadingText variant="h4">Feedbacks</StyledHeadingText>
            </StyledHeaderContainer>
            <FeedbackList />
        </RouteContainer>
    )
}
